import React, { useState, useEffect } from "react";
import axios from "axios";

import { getApiUrl, API_ENDPOINTS, API_BASE_URL } from "../../../config/api";

const AccountChequeFormModal = ({ cheques, setCheques, editingCheque, onClose }) => {
  const [formData, setFormData] = useState({
    acc: "", // This will now store the selected account ID
    cheque_number_start: "",
    cheque_number_end: "",
  });

  const [accounts, setAccounts] = useState([]); // To store fetched account details

  // Fetch account details from the API
  useEffect(() => {
    const fetchAccountDetails = async () => {
      try {
        const accessToken = localStorage.getItem("access_token");
        const response = await axios.get(getApiUrl("/PartnerFiles/account-details/"), {
          headers: { Authorization: `Bearer ${accessToken}` },
        });
        setAccounts(response.data.data); // Store the fetched accounts
      } catch (error) {
        console.error("Error fetching account details:", error);
      }
    };
    fetchAccountDetails();
  }, []);

  // Update formData whenever editingCheque changes
  useEffect(() => {
    if (editingCheque) {
      setFormData({
        acc: editingCheque.acc || "",
        cheque_number_start: editingCheque.cheque_number_start || "",
        cheque_number_end: editingCheque.cheque_number_end || "",
      });
    } else {
      setFormData({ acc: "", cheque_number_start: "", cheque_number_end: "" });
    }
  }, [editingCheque]);

  // Handle form input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const accessToken = localStorage.getItem("access_token");
      if (editingCheque) {
        // Update existing cheque
        await axios.put(
          getApiUrl(`/PartnerFiles/api/cheques/${editingCheque.id}/`),
          formData,
          { headers: { Authorization: `Bearer ${accessToken}` } }
        );
        setCheques(
          cheques.map((cheque) =>
            cheque.id === editingCheque.id ? { ...cheque, ...formData } : cheque
          )
        );
      } else {
        // Create new cheque
        const response = await axios.post(
          getApiUrl("/PartnerFiles/api/cheques/create/"),
          formData,
          { headers: { Authorization: `Bearer ${accessToken}` } }
        );
        setCheques([...cheques, response.data]);
      }
      onClose(); // Close modal after submission
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  return (
    <div
      className="fixed inset-0 flex justify-center items-center z-50"
      id="marketingmodalopen"
      style={{ width: "100vw", height: "100vh" }}
    >
      {/* Background overlay */}
      <div
        className="absolute inset-0 bg-gray-800 bg-opacity-60 backdrop-blur-sm"
        style={{
          width: "100vw",
          height: "150%",
          background: "black",
          backgroundSize: "200% 200vh",
          overflowY: "hidden",
          paddingBottom: "150px",
        }}
      ></div>

      {/* Modal content */}
      <div
        className="relative bg-white w-4/5 max-w-4xl rounded-lg shadow-lg"
        style={{
          height: "95vh", // Set height to allow scrolling
          overflowY: "auto", // Enable scrolling inside modal
        }}
      >
        <div
          className="overflow-auto max-h-[80vh]"
          style={{ padding: "100px", paddingTop: "20px" }}
        >
          <h2 className="text-center text-blue-700 mb-5">
            {editingCheque ? "Edit Cheque" : "Add Cheque"}
          </h2>
          <button
            type="button"
            onClick={onClose}
            className="bg-blue-500 text-white px-3 py-2 rounded hover:bg-red-700 transition-colors"
            style={{ position: "absolute", top: "20px", right: "20px" }}
          >
            X
          </button>

          {/* Form Fields */}
          <form onSubmit={handleSubmit}>
            {/* Account Dropdown */}
            <div className="mb-4">
              <label
                htmlFor="acc"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Select Account:
              </label>
              <select
                id="acc"
                name="acc"
                value={formData.acc}
                onChange={handleChange}
                required
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="">-- Select an account --</option>
  {accounts.map((account) => (
    <option key={account.id} value={account.id}>
      {account.acc_name ? `${account.acc_name} (${account.acc_number})` : `Account ID: ${account.id}`}
    </option>
  ))}
              </select>
            </div>

            {/* Cheque Number Start */}
            <div className="mb-4">
              <label
                htmlFor="cheque_number_start"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Cheque Number Start:
              </label>
              <input
                type="text"
                id="cheque_number_start"
                name="cheque_number_start"
                value={formData.cheque_number_start}
                onChange={handleChange}
                required
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            {/* Cheque Number End */}
            <div className="mb-4">
              <label
                htmlFor="cheque_number_end"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Cheque Number End:
              </label>
              <input
                type="text"
                id="cheque_number_end"
                name="cheque_number_end"
                value={formData.cheque_number_end}
                onChange={handleChange}
                required
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            {/* Action Buttons */}
            <div className="flex space-x-4">
              <button
                type="submit"
                className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition duration-200"
              >
                {editingCheque ? "Update" : "Create"}
              </button>
              <button
                type="button"
                onClick={onClose}
                className="px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400 transition duration-200"
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AccountChequeFormModal;